<template>
    <div>
        <div class="grid-content bg-purple">
          <div id="echartContainer" style="width:100%; height:388px;"></div>
        </div>
    </div>
</template>
<script>
import { Decrypt } from "../until/ZeusApiSDK/Logic/CryptoLogic";
import { GeteUserBaseList } from "../until/ZeusApiSDK/Logic/StructureLogic";
import {GetAttendanceDay,GeteAttendanceSummary} from "../until/ZeusApiSDK/Logic/AttendanceListLogic";

const echarts = require("echarts");
export default {
    props:{
        value:{
        type:Date,
        default:()=>new Date
        }
    },
    data() {
        return {
        }
    },
    mounted() {
        this.$nextTick(() => {
        // 点击前一个月
        let prevBtn = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(1)"
        );
        prevBtn.addEventListener("click", () => {
            // console.log('上一月'+this.value.toDateString()+"??"+this.currentUser.TrueName+"??"+this.currentUser.UserCode);
            this.joinValue =
            new Date().getFullYear() + "-" + (this.value.getMonth() + 1) + "-01";
            this.geteAttendance();
            var dataSum = {
            Month: this.value.getMonth() + 1,
            CurrentUserCode: this.currentUser.UserCode
            };
            GeteAttendanceSummary(dataSum).then(res => {
            if (res.model != null) {
                //基于准备好的dom, 初始化echarts实例
                this.model = res.model;
                this.chModelList = res.chModelList;
                this.chModelList1 = res.chModelList1;
                this.DataName = res.DataName;
                let myChart = echarts.init(
                document.getElementById("echartContainer")
                );
                myChart.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    x: "left",
                    data: this.DataName
                },
                series: [
                    {
                    name: "",
                    type: "pie",
                    selectedMode: "single",
                    radius: [0, "30%"],

                    label: {
                        normal: {
                        position: "inner"
                        }
                    },
                    labelLine: {
                        normal: {
                        show: false
                        }
                    },
                    data: this.chModelList
                    //data:[{"value":22,"name":"正常出勤天数"}]
                    },
                    {
                    name: "",
                    type: "pie",
                    radius: ["40%", "55%"],
                    label: {
                        normal: {
                        formatter:
                            "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                        backgroundColor: "#eee",
                        borderColor: "#aaa",
                        borderWidth: 1,
                        borderRadius: 4,
                        rich: {
                            a: {
                            color: "#999",
                            lineHeight: 22,
                            align: "center"
                            },
                            hr: {
                            borderColor: "#aaa",
                            width: "100%",
                            borderWidth: 0.5,
                            height: 0
                            },
                            b: {
                            fontSize: 16,
                            lineHeight: 33
                            },
                            per: {
                            color: "#eee",
                            backgroundColor: "#334455",
                            padding: [2, 4],
                            borderRadius: 2
                            }
                        }
                        }
                    },
                    data: this.chModelList1
                    }
                ]
                });
            } else {
                // this.open();
                this.model = " ";
                this.chModelList = [];
                this.chModelList1 = [];
                this.DataName = " ";
                let myChart = echarts.init(
                document.getElementById("echartContainer")
                );
                myChart.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    x: "left",
                    data: this.DataName
                },
                series: [
                    {
                    name: "",
                    type: "pie",
                    selectedMode: "single",
                    radius: [0, "30%"],

                    label: {
                        normal: {
                        position: "inner"
                        }
                    },
                    labelLine: {
                        normal: {
                        show: false
                        }
                    },
                    data: this.chModelList
                    //data:[{"value":22,"name":"正常出勤天数"}]
                    },
                    {
                    name: "",
                    type: "pie",
                    radius: ["40%", "55%"],
                    label: {
                        normal: {
                        formatter:
                            "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                        backgroundColor: "#eee",
                        borderColor: "#aaa",
                        borderWidth: 1,
                        borderRadius: 4,
                        rich: {
                            a: {
                            color: "#999",
                            lineHeight: 22,
                            align: "center"
                            },
                            hr: {
                            borderColor: "#aaa",
                            width: "100%",
                            borderWidth: 0.5,
                            height: 0
                            },
                            b: {
                            fontSize: 16,
                            lineHeight: 33
                            },
                            per: {
                            color: "#eee",
                            backgroundColor: "#334455",
                            padding: [2, 4],
                            borderRadius: 2
                            }
                        }
                        }
                    },
                    data: this.chModelList1
                    }
                ]
                });
            }
            });
        });
        // 点击 今天
        let todayBtn = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(2)"
        );
        todayBtn.addEventListener("click", () => {
            //console.log('今天'+this.value.toDateString()+"??"+this.currentUser.TrueName+"??"+this.currentUser.UserCode);
            this.joinValue =
            new Date().getFullYear() + "-" + (this.value.getMonth() + 1) + "-01";
            this.geteAttendance();
            var dataSum = {
            Year:"0",
            Month: this.value.getMonth() + 1,
            CurrentUserCode: this.currentUser.UserCode
            };
          
            GeteAttendanceSummary(dataSum).then(res => {
            if (res.model != null) {
                //基于准备好的dom, 初始化echarts实例
                this.model = res.model;
                this.chModelList = res.chModelList;
                this.chModelList1 = res.chModelList1;
                this.DataName = res.DataName;
                let myChart = echarts.init(
                document.getElementById("echartContainer")
                );
                myChart.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    x: "left",
                    data: this.DataName
                },
                series: [
                    {
                    name: "",
                    type: "pie",
                    selectedMode: "single",
                    radius: [0, "30%"],

                    label: {
                        normal: {
                        position: "inner"
                        }
                    },
                    labelLine: {
                        normal: {
                        show: false
                        }
                    },
                    data: this.chModelList
                    //data:[{"value":22,"name":"正常出勤天数"}]
                    },
                    {
                    name: "",
                    type: "pie",
                    radius: ["40%", "55%"],
                    label: {
                        normal: {
                        formatter:
                            "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                        backgroundColor: "#eee",
                        borderColor: "#aaa",
                        borderWidth: 1,
                        borderRadius: 4,
                        rich: {
                            a: {
                            color: "#999",
                            lineHeight: 22,
                            align: "center"
                            },
                            hr: {
                            borderColor: "#aaa",
                            width: "100%",
                            borderWidth: 0.5,
                            height: 0
                            },
                            b: {
                            fontSize: 16,
                            lineHeight: 33
                            },
                            per: {
                            color: "#eee",
                            backgroundColor: "#334455",
                            padding: [2, 4],
                            borderRadius: 2
                            }
                        }
                        }
                    },
                    data: this.chModelList1
                    }
                ]
                });
            } else {
                // this.open();
                this.model = " ";
                this.chModelList = [];
                this.chModelList1 = [];
                this.DataName = " ";
                let myChart = echarts.init(
                document.getElementById("echartContainer")
                );
                myChart.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    x: "left",
                    data: this.DataName
                },
                series: [
                    {
                    name: "",
                    type: "pie",
                    selectedMode: "single",
                    radius: [0, "30%"],

                    label: {
                        normal: {
                        position: "inner",
                        }
                    },
                    labelLine: {
                        normal: {
                        show: false
                        }
                    },
                    data: this.chModelList
                    //data:[{"value":22,"name":"正常出勤天数"}]
                    },
                    {
                    name: "",
                    type: "pie",
                    radius: ["40%", "55%"],
                    label: {
                        normal: {
                        formatter:
                            "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                        backgroundColor: "#eee",
                        borderColor: "#aaa",
                        borderWidth: 1,
                        borderRadius: 4,
                        rich: {
                            a: {
                            color: "#999",
                            lineHeight: 22,
                            align: "center"
                            },
                            hr: {
                            borderColor: "#aaa",
                            width: "100%",
                            borderWidth: 0.5,
                            height: 0
                            },
                            b: {
                            fontSize: 16,
                            lineHeight: 33
                            },
                            per: {
                            color: "#eee",
                            backgroundColor: "#334455",
                            padding: [2, 4],
                            borderRadius: 2
                            }
                        }
                        }
                    },
                    data: this.chModelList1
                    }
                ]
                });
            }
            });
        });
        // 点击后一个月
        let nextBtn = document.querySelector(
            ".el-calendar__button-group .el-button-group>button:nth-child(3)"
        );
        nextBtn.addEventListener("click", () => {
            //console.log('下一月'+this.value.toDateString()+"??"+this.currentUser.TrueName+"??"+this.currentUser.UserCode);
            this.joinValue = new Date().getFullYear() + "-" + (this.value.getMonth() + 1) + "-01";
            // this.joinValue = new Date().getFullYear() + "-" + (this.value.getMonth() ) + "-01";
            this.geteAttendance();
            var dataSum = {
            Month: this.value.getMonth() + 1,
            // Month: this.value.getMonth(),
            CurrentUserCode: this.currentUser.UserCode
            };
            GeteAttendanceSummary(dataSum).then(res => {
            if (res.model != null) {
                //基于准备好的dom, 初始化echarts实例
                this.model = res.model;
                this.chModelList = res.chModelList;
                this.chModelList1 = res.chModelList1;
                this.DataName = res.DataName;
                let myChart = echarts.init(
                document.getElementById("echartContainer")
                );
                myChart.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    x: "left",
                    data: this.DataName
                },
                series: [
                    {
                    name: "",
                    type: "pie",
                    selectedMode: "single",
                    radius: [0, "30%"],

                    label: {
                        normal: {
                        show:false,
                        position: "inner"
                        }
                    },
                    labelLine: {
                        normal: {
                        show: false
                        }
                    },
                    data: this.chModelList
                    },
                    {
                    name: "",
                    type: "pie",
                    radius: ["40%", "55%"],
                    label: {
                        normal: {
                        show:false,
                        formatter:
                            "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                        backgroundColor: "#eee",
                        borderColor: "#aaa",
                        borderWidth: 1,
                        borderRadius: 4,
                        rich: {
                            a: {
                            color: "#999",
                            lineHeight: 22,
                            align: "center"
                            },
                            hr: {
                            borderColor: "#aaa",
                            width: "100%",
                            borderWidth: 0.5,
                            height: 0
                            },
                            b: {
                            fontSize: 16,
                            lineHeight: 33
                            },
                            per: {
                            color: "#eee",
                            backgroundColor: "#334455",
                            padding: [2, 4],
                            borderRadius: 2
                            }
                        }
                        }
                    },
                    data: this.chModelList1
                    }
                ]
                });
            } else {
                // this.open();
                this.model = " ";
                this.chModelList = [];
                this.chModelList1 = [];
                this.DataName = " ";
                let myChart = echarts.init(
                document.getElementById("echartContainer")
                );
                myChart.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    x: "left",
                    data: this.DataName
                },
                series: [
                    {
                    name: "",
                    type: "pie",
                    selectedMode: "single",
                    radius: [0, "30%"],

                    label: {
                        normal: {
                        show:false,
                        position: "inner"
                        }
                    },
                    labelLine: {
                        normal: {
                        show: false
                        }
                    },
                    data: this.chModelList
                    },
                    {
                    name: "",
                    type: "pie",
                    radius: ["40%", "55%"],
                    label: {
                        normal: {
                        show:false,
                        formatter:
                            "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                        backgroundColor: "#eee",
                        borderColor: "#aaa",
                        borderWidth: 1,
                        borderRadius: 4,
                        rich: {
                            a: {
                            color: "#999",
                            lineHeight: 22,
                            align: "center"
                            },
                            hr: {
                            borderColor: "#aaa",
                            width: "100%",
                            borderWidth: 0.5,
                            height: 0
                            },
                            b: {
                            fontSize: 16,
                            lineHeight: 33
                            },
                            per: {
                            color: "#eee",
                            backgroundColor: "#334455",
                            padding: [2, 4],
                            borderRadius: 2
                            }
                        }
                        }
                    },
                    data: this.chModelList1
                    }
                ]
                });
            }
            });
        });
        });
        var data = {
        datetimes: this.value.toDateString(),
        name: this.currentUser.TrueName,
        userCode: this.currentUser.UserCode
        };

        var dataSum = {
         Year:"0",   
        Month: this.value.getMonth() + 1, //当前月份
        CurrentUserCode: this.currentUser.UserCode
        };

        GeteAttendanceSummary(dataSum).then(res => {
            if (res.model != null) {
                //基于准备好的dom, 初始化echarts实例
                this.chModelList = res.chModelList;
                this.chModelList1 = res.chModelList1;
                this.DataName = res.DataName;
                this.model = res.model;
                let myChart = echarts.init(document.getElementById("echartContainer"));
                myChart.setOption({
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: "vertical",
                    x: "left",
                    data: this.DataName
                },
                series: [
                    {
                    name: "",
                    type: "pie",
                    selectedMode: "single",
                    radius: [0, "30%"],
                    label: {
                        normal: {
                        position: "inner"
                        }
                    },
                    labelLine: {
                        normal: {
                        show: false
                        }
                    },
                    data: this.chModelList
                    //data:[{"value":22,"name":"正常出勤天数"}]
                    },
                    {
                    name: "",
                    type: "pie",
                    radius: ["40%", "55%"],
                    label: {
                        normal: {
                        // formatter:
                        //     "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                        // backgroundColor: "#eee",
                        // borderColor: "#aaa",
                        // borderWidth: 1,
                        // borderRadius: 4,
                        // rich: {
                            // a: {
                            // color: "#999",
                            // lineHeight: 22,
                            // align: "center"
                            // },
                            // hr: {
                            // borderColor: "#aaa",
                            // width: "100%",
                            // borderWidth: 0.5,
                            // height: 0
                            // },
                        //     b: {
                        //     fontSize: 16,
                        //     lineHeight: 33
                        //     },
                        //     per: {
                        //     color: "#eee",
                        //     backgroundColor: "#334455",
                        //     padding: [2, 4],
                        //     borderRadius: 2
                        //     }
                        // }
                        }
                    },
                    data: this.chModelList1
                    }
                ]
                });
            } else {
                dataSum = {
                    Month: this.value.getMonth(), //当前月份
                    CurrentUserCode: this.currentUser.UserCode
                };
                GeteAttendanceSummary(dataSum).then(result=>{
                    if(result.model!=null){
                        //基于准备好的dom, 初始化echarts实例
                        this.chModelList = result.chModelList;
                        this.chModelList1 = result.chModelList1;
                        this.DataName = result.DataName;
                        this.model = result.model;
                        let myChart = echarts.init(document.getElementById("echartContainer"));
                        myChart.setOption({
                        tooltip: {
                            trigger: "item",
                            formatter: "{a} <br/>{b}: {c} ({d}%)"
                        },
                        legend: {
                            orient: "vertical",
                            x: "left",
                            data: this.DataName
                        },
                        series: [
                            {
                            name: "",
                            type: "pie",
                            selectedMode: "single",
                            radius: [0, "30%"],
                            label: {
                                normal: {
                                position: "inner"
                                }
                            },
                            labelLine: {
                                normal: {
                                show: false
                                }
                            },
                            data: this.chModelList
                            //data:[{"value":22,"name":"正常出勤天数"}]
                            },
                            {
                            name: "",
                            type: "pie",
                            radius: ["40%", "55%"],
                            label: {
                                normal: {
                                }
                            },
                            data: this.chModelList1
                            }
                        ]
                        });
                    }
                });
                // this.model = " ";
                // this.chModelList = [];
                // this.chModelList1 = [];
                // this.DataName = " ";
                // let myChart = echarts.init(document.getElementById("echartContainer"));
                // myChart.setOption({
                // tooltip: {
                //     trigger: "item",
                //     formatter: "{a} <br/>{b}: {c} ({d}%)"
                // },
                // legend: {
                //     orient: "vertical",
                //     x: "left",
                //     data: this.DataName
                // },
                // series: [
                //     {
                //     name: "",
                //     type: "pie",
                //     selectedMode: "single",
                //     radius: [0, "30%"],
                //     label: {
                //         normal: {
                //         position: "inner"
                //         }
                //     },
                //     labelLine: {
                //         normal: {
                //         show: false
                //         }
                //     },
                //     data: this.chModelList
                //     //data:[{"value":22,"name":"正常出勤天数"}]
                //     },
                //     {
                //     name: "",
                //     type: "pie",
                //     radius: ["40%", "55%"],
                //     label: {
                //         normal: {
                //         formatter:
                //             "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                //         backgroundColor: "#eee",
                //         borderColor: "#aaa",
                //         borderWidth: 1,
                //         borderRadius: 4,
                //         rich: {
                //             a: {
                //             color: "#999",
                //             lineHeight: 22,
                //             align: "center"
                //             },
                //             hr: {
                //             borderColor: "#aaa",
                //             width: "100%",
                //             borderWidth: 0.5,
                //             height: 0
                //             },
                //             b: {
                //             fontSize: 16,
                //             lineHeight: 33
                //             },
                //             per: {
                //             color: "#eee",
                //             backgroundColor: "#334455",
                //             padding: [2, 4],
                //             borderRadius: 2
                //             }
                //         }
                //         }
                //     },
                //     data: this.chModelList1
                //     }
                // ]
                // });
            }
        });
    },
    //页面进入加载事件
    created: function() {
        //获取当前用户
        this.getCurrentUser();
        //获取当前用户信息
        this.getUserInfo();
        //获取考勤日历
        this.geteAttendance();
    },
    methods: {
        //获取当前用户
        getCurrentUser: function() {
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        //获取当前用户信息
        getUserInfo: function() {
            //构造参数
            var predicates = [
                {
                Field: "UserID",
                Value: this.currentUser.UserId,
                Oper: "eq",
                IsAnd: 1
                }
            ];
            //获取userBase基本信息
            GeteUserBaseList(predicates).then(res => {
                if (res.length > 0) {
                this.userBase = res[0];
                }
            });
        },
        //获取考勤信息
        geteAttendance: async function() {
            if (this.joinValue == "" || this.joinValue == null) {
                this.joinValue = this.value.toDateString();
            }
            var data = {
                //datetimes:this.value.toDateString(),
                datetimes: this.joinValue,
                name: this.currentUser.TrueName,
                userCode: this.currentUser.UserCode
            };
            //   var dataSum={
            //     Month:this.value.getMonth()+1,
            //     CurrentUserCode:this.currentUser.UserCode
            // };
            await GetAttendanceDay(data).then(res => {
                this.calendarData = res.listCalendarData;
                this.list = res.list;
            });
        },
    }
}
</script>